const DEFAULT_RAG_PROMPT_TEMPLATE =
  "Use the following context to answer the question.\n\nContext:\n{context}\n\nQuestion:\n{query}";

export function formatRagPrompt(
  context: string,
  query: string,
  template = DEFAULT_RAG_PROMPT_TEMPLATE,
): string {
  return template.replace(/\{(context|query)\}/g, (_, placeholder: "context" | "query") =>
    placeholder === "context" ? context : query,
  );
}
